import * as React from "react"

type Props = {
  sizeY?: string
  sizeX?: string
  lgSizeY?: string
  lgSizeX?: string
}

const Space: React.FC<Props> = ({
  sizeX = "",
  sizeY = "",
  lgSizeX = "",
  lgSizeY = "",
}) => (
  <div
    className={[
      ...(sizeY ? [`h-${sizeY}`] : []),
      ...(sizeX ? [`w-${sizeX}`] : []),
      ...(lgSizeY ? [`lg:h-${lgSizeY}`] : []),
      ...(lgSizeX ? [`lg:w-${lgSizeX}`] : []),
    ].join(` `)}
  />
)

export default Space
